module.exports = __webpack_public_path__ + "static/media/vfl-snackBar-phone.317ba1fb.png";